import { NgModule } from '@angular/core';
import { LibEmailVerificationIconComponent } from './lib-email-verification-icon.component';

@NgModule({
  declarations: [LibEmailVerificationIconComponent],
  imports: [],
  exports: [LibEmailVerificationIconComponent],
})
export class LibEmailVerificationIconModule {}
